import './App.scss';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainContent from './mainContent';
// import PrivacyPolicy from './privacy-policy';
// import TermsAndConditions from './terms-and-conditions';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainContent />} />
          {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
